import { FaBars } from "react-icons/fa";
import logo from "../../../src/assets/images/DSS.png";
import { useNavigate, useLocation } from "react-router-dom";
import { IoClose } from "react-icons/io5";
import { useState } from "react";
import React from "react";

const BottomNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const getLinkClass = (path) => {
    return location.pathname === path
      ? "text-base text-[#235784] font-semibold cursor-pointer tracking-wide"
      : "text-base hover:text-[#235784] hover:font-semibold cursor-pointer tracking-wide";
  };

  return (
    <div className="sticky top-0 w-full z-50">
      <nav className="hidden md:block bg-[#BED1E9] py-1 text-center">
        <div>
          <h1
            className="text-sm lg:text-base poppins text-[#252525] py-2"
            id="allura"
          >
            In case of any Query. Kindly email at{" "}
            <span className="font-bold text-black">
              support@drivesafesolutions.in
            </span>{" "}
            or contact us at{" "}
            <span className="font-bold text-black">+91 91245 78108</span>
          </h1>
        </div>
      </nav>

      {/* Navbar */}
      <nav className="bg-[#fffefc] text-[#26232A] px-6 xl:px-16 lg:px-14 md:px-10 py-1 shadow-2xl">
        <div className="container mx-auto flex items-center justify-between ">
          <div className="h-20 w-24 flex justify-center items-center">
            <img
              src={logo}
              alt="Driving-safe-solution"
              className="w-auto h-auto"
            />
          </div>
          <div className="hidden lg:block lg:flex space-x-16 oxygen lg:justify-between md:justify-center  items-center ">
            <div onClick={() => navigate("/")} className={getLinkClass("/")}>
              Home
            </div>
            <div
              onClick={() => {
                navigate("/");
                setTimeout(() => {
                  document
                    .getElementById("whychooseus")
                    .scrollIntoView({ behavior: "smooth" });
                }, 100);
              }}
              className={getLinkClass("/about")}
            >
              About us
            </div>

            <div
              onClick={() => {
                navigate("/");
                setTimeout(() => {
                  document
                    .getElementById("services")
                    .scrollIntoView({ behavior: "smooth" });
                }, 100);
              }}
              className={getLinkClass("/services")}
            >
              Services
            </div>

            <div
              onClick={() => {
                navigate("/gps");
              }}
              className={getLinkClass("/gps")}
            >
              Gps
            </div>

            <div
              onClick={() => {
                navigate("/");
                setTimeout(() => {
                  document
                    .getElementById("partners")
                    .scrollIntoView({ behavior: "smooth" });
                }, 100);
              }}
              className={getLinkClass("/partners")}
            >
              Partner Banks
            </div>
          </div>
          <div className="hidden lg:block ">
            <button
              onClick={() => navigate("/contact")}
              className="tracking-wide bg-[#F26422] text-white font-bold lg:py-2 lg:px-6 rounded"
            >
              Contact us
            </button>
          </div>
          <div className="lg:hidden">
            <FaBars
              onClick={toggleSidebar}
              size={24}
              className="cursor-pointer"
            />
          </div>
        </div>
      </nav>
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 z-50">
          <div className="fixed top-0 left-0 w-64 h-full bg-white shadow-md">
            <div className="p-4">
              <button
                className="text-black text-lg font-bold mb-8 float-right"
                onClick={toggleSidebar}
              >
                <IoClose size={25} className="text-blue-500" />
              </button>

              <ul className="space-y-4 text-lg">
                <li
                  onClick={() => {
                    navigate("/");
                    toggleSidebar();
                  }}
                  className={getLinkClass("/")}
                >
                  Home
                </li>
                <li
                  onClick={() => {
                    navigate("/");
                    setTimeout(() => {
                      document
                        .getElementById("whychooseus")
                        .scrollIntoView({ behavior: "smooth" });
                    });
                    toggleSidebar();
                  }}
                  className={getLinkClass("/about")}
                >
                  About us
                </li>
                <li
                  onClick={() => {
                    navigate("/");
                    setTimeout(() => {
                      document
                        .getElementById("services")
                        .scrollIntoView({ behavior: "smooth" });
                    });
                    toggleSidebar();
                  }}
                  className={getLinkClass("/services")}
                >
                  Services
                </li>
                <li
                  onClick={() => {
                    navigate("/");
                    setTimeout(() => {
                      document
                        .getElementById("gps")
                        .scrollIntoView({ behavior: "smooth" });
                    });
                    toggleSidebar();
                  }}
                  className={getLinkClass("/gps")}
                >
                  Gps
                </li>
                <li
                  onClick={() => {
                    navigate("/");
                    setTimeout(() => {
                      document
                        .getElementById("partners")
                        .scrollIntoView({ behavior: "smooth" });
                    });
                    toggleSidebar();
                  }}
                  className={getLinkClass("/partners")}
                >
                  Partner Banks
                </li>
              </ul>
              <button
                onClick={() => {
                  navigate("/contact");
                  toggleSidebar();
                }}
                className="tracking-wide mt-8 bg-[#F26422] text-white font-bold py-2 px-4 rounded"
              >
                Contact us
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BottomNavbar;
